import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";

// Components
import Sidebar from "./Sidebar";

class SidebarContainer extends Component {
  render() {
    return <Sidebar loginReducer={this.props.loginReducer} />;
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

function mapStateToProps(state) {
  return {
    loginReducer: state.loginReducer,
  };
}

export default withRouter(
  connect(mapStateToProps, matchDispatchToProps)(SidebarContainer)
);
